import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";

import CountryDetailPage from "./country/CountryDetailPage";
import { CountryPage } from "./country/CountryPage";
import { DepotDetails } from "./depots/depot-details/DepotDetails";
import { DepotsPage } from "./depots/DepotsPage";
import { Feeds } from "./feeds/Feeds";
import { FranchiseDetails } from "./franchises/franchise-details/FranchiseDetails";
import { FranchisesPage } from "./franchises/FranchisesPage";
import { DebtCollectionPage } from "./debt-collection/DebtCollectionPage";
import { ConectiaValidationPage } from "./conectia-validation/ConectiaValidationPage";
import { ProductDetails } from "./products/product-edit/ProductDetail/ProductDetails";
import { ProductsPage } from "./products/ProductsPage";
import ProfileDetailPage from "./user/ProfileDetailPage";
import PromotionsDetailPage from "./promotions/PromotionsDetailPage";
import { PromotionsPage } from "./promotions/PromotionsPage";
import { ReportingPage } from "./reporting/ReportingPage";
import UserDetailPage from "./user/UserDetailPage";
import { UserPage } from "./user/UserPage";
import { Availability } from "./Availability";
import { ExportImport } from "./ExportImport";
import { ContainerPage } from "./container/ContainerPage";
import LogsPage from "./franchises/Logs component/LogsPage";

/**
 * Routes under `settings/*`. Mounted from BasePage, so child paths here are
 * relative (no leading `/settings/`). Pages guard their own roles.
 * @returns {JSX.Element} The settings routes.
 */
export default function SettingPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        <Route path="" element={<Navigate to="/setting-page" replace />} />

        {ContentRoute({ path: "reports", component: ExportImport })}
        {ContentRoute({ path: "products/product-details/:id", component: ProductDetails })}
        {ContentRoute({
          path: "franchises/franchise-details/:id/:name/products/:p_id",
          component: ProductDetails,
        })}
        {ContentRoute({ path: "products", component: ProductsPage })}
        {ContentRoute({
          path: "franchises/franchise-details/:id",
          component: FranchiseDetails,
        })}
        {ContentRoute({
          path: "franchises/franchise-details/:id/:name/products",
          component: ProductsPage,
        })}
        {ContentRoute({
          path: "franchises/franchise-details/:id/:name/logs",
          component: LogsPage,
        })}
        {ContentRoute({ path: "franchises", component: FranchisesPage })}
        {ContentRoute({ path: "franchise-debt", component: DebtCollectionPage })}
        {ContentRoute({ path: "conectia-validation", component: ConectiaValidationPage })}
        {ContentRoute({ path: "country", component: CountryPage })}
        {ContentRoute({
          path: "country/country-details/:id",
          component: CountryDetailPage,
        })}
        {ContentRoute({ path: "promotions", component: PromotionsPage })}
        {ContentRoute({
          path: "promotions/promotions-details/:id",
          component: PromotionsDetailPage,
        })}
        {ContentRoute({ path: "reporting", component: ReportingPage })}
        {ContentRoute({ path: "users", component: UserPage })}
        {ContentRoute({
          path: "users/user-details/:id",
          component: UserDetailPage,
        })}
        {ContentRoute({
          path: "users/profile-details/:id",
          component: ProfileDetailPage,
        })}

        {ContentRoute({
          path: "depots/depot-details/:id",
          component: DepotDetails,
        })}
        {ContentRoute({ path: "feeds", component: Feeds })}
        {ContentRoute({ path: "depots", component: DepotsPage })}

        {ContentRoute({ path: "timeline", component: Feeds })}
        {ContentRoute({
          path: "sales-agent-availability",
          component: Availability,
        })}
        {ContentRoute({ path: "container", component: ContainerPage })}
      </Routes>
    </Suspense>
  );
}
